import {
  add2suhfggl4zvkk as add,
  subtract2orl8z9upxd9l as subtract,
  fromInt2ii0rejb1w62w as fromInt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { Buffergs925ekssbch as Buffer } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import {
  awaitContent$default2k2a3zkrv0yyf as awaitContent$default,
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
} from './ByteReadChannel.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function transferFromDelegate($this) {
  updateConsumed($this);
  var appended = $this.e4o_1.o4j($this.d4o_1.b4m());
  $this.f4o_1 = add($this.f4o_1, appended);
}
function updateConsumed($this) {
  $this.g4o_1 = add($this.g4o_1, subtract($this.f4o_1, $this.e4o_1.q2()));
  $this.f4o_1 = $this.e4o_1.q2();
}
var CountedByteReadChannelClass;
function CountedByteReadChannel() {
  if (CountedByteReadChannelClass === VOID) {
    class $ {
      constructor(delegate) {
        this.d4o_1 = delegate;
        this.e4o_1 = new (Buffer())();
        this.f4o_1 = 0n;
        this.g4o_1 = 0n;
      }
      h4o() {
        updateConsumed(this);
        return this.g4o_1;
      }
      x4l() {
        return this.d4o_1.x4l();
      }
      s4m() {
        return this.e4o_1.j3y() && this.d4o_1.s4m();
      }
      b4m() {
        transferFromDelegate(this);
        return this.e4o_1;
      }
      *t4m(min, $completion) {
        if (this.b4m().q2() >= fromInt(min)) {
          return true;
        }
        if (yield* this.d4o_1.t4m(min, $completion)) {
          transferFromDelegate(this);
          return true;
        }
        return false;
      }
      d4n(cause) {
        this.d4o_1.d4n(cause);
        this.e4o_1.m6();
      }
    }
    protoOf($).z4m = awaitContent$default;
    initMetadataForClass($, 'CountedByteReadChannel', VOID, VOID, [ByteReadChannel()], [1]);
    CountedByteReadChannelClass = $;
  }
  return CountedByteReadChannelClass;
}
function counted(_this__u8e3s4) {
  return new (CountedByteReadChannel())(_this__u8e3s4);
}
//region block: exports
export {
  counted as counted3iniv3aql3f9n,
};
//endregion

//# sourceMappingURL=CountedByteReadChannel.mjs.map
